var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2V12H11.5V2H10.5ZM3.99057 7.76068C4.60866 6.49198 5.57988 5.41127 6.76821 4.65605L6.23184 3.81207C4.88954 4.66514 3.79226 5.88515 3.09227 7.32131C0.930227 11.6914 2.69515 16.9915 7.06928 19.1565C11.4397 21.3196 16.7407 19.5548 18.9059 15.1802C20.9262 11.0982 19.5202 6.20536 15.7614 3.81229L15.2244 4.65584C18.5534 6.77527 19.8028 11.1136 18.0096 14.7366C16.0915 18.612 11.3925 20.1805 7.51287 18.2603C3.63747 16.3421 2.06897 11.6431 3.98919 7.76349L3.99057 7.76068Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.f476e08def245f9da6f12c599f95cd4a.svg";
export { ForwardRef as ReactComponent };